import { render } from "./RenderAlert.vue?vue&type=template&id=704ff8f8&scoped=true"
import script from "./RenderAlert.vue?vue&type=script&lang=js"
export * from "./RenderAlert.vue?vue&type=script&lang=js"

import "./RenderAlert.vue?vue&type=style&index=0&id=704ff8f8&lang=scss"
import "./RenderAlert.vue?vue&type=style&index=1&id=704ff8f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704ff8f8"],['__file',"webpack-assets/vue/components/RenderAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "704ff8f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('704ff8f8', __exports__)) {
    api.reload('704ff8f8', __exports__)
  }
  
  module.hot.accept("./RenderAlert.vue?vue&type=template&id=704ff8f8&scoped=true", () => {
    api.rerender('704ff8f8', render)
  })

}


export default __exports__